import SearchResultList from "components/common/SearchResultList";
import UnitCat from "../UnitCat/UnitCat";
import { DlUnit } from "model/dl_unit/DlUnit";

type UnitListProps = {
  units: DlUnit[];
};

const UnitList = ({ units }: UnitListProps) => {
  return (
    <div>
      {/* <TopicSearchFilters searchHandle={searchHandle} /> */}
      <SearchResultList<DlUnit>
        renderSingle={(item: DlUnit, ind: number) => (
          <UnitCat
            item={new DlUnit(item)}
            catInd={ind + 1}
            key={`unit_${ind + 1}`}
          />
        )}
        results={units}
        // pageNavigation={pageNavigation}
      />
    </div>
  );
};

export default UnitList;
